const Util = {
	UpdateUrlHash(hash) {
		// make sure we're dealing with a good hash
		if (typeof hash !== 'undefined') {
			// ensure consistency
			if (hash.indexOf('#') < 0) {
				// eslint-disable-next-line no-param-reassign
				hash = `#${hash}`;
			}

			if (window.history.replaceState) {
				window.history.replaceState(null, null, hash);
			} else {
				window.location.replace(hash);
			}
		}
	}
};

export default Util;
